import { atom } from "recoil";

export const supportAction = atom<boolean>({
  key: 'supportAction',
  default: false
});
